var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.2,
    height: 16,
    viewBox: "0 0 15.2 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_95596",
    "data-name": "Group 95596",
    transform: "translate(-1310.799 -340)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icons8-trash",
    d: "M12.6,4A2.809,2.809,0,0,0,9.832,6.4H7.1a.539.539,0,0,0-.192,0H5.6a.6.6,0,1,0,0,1.2h.855L7.462,18.012A2.208,2.208,0,0,0,9.652,20h5.895a2.207,2.207,0,0,0,2.19-1.988L18.744,7.6H19.6a.6.6,0,1,0,0-1.2H18.3a.6.6,0,0,0-.192,0H15.368A2.809,2.809,0,0,0,12.6,4Zm0,1.2a1.585,1.585,0,0,1,1.545,1.2H11.055A1.585,1.585,0,0,1,12.6,5.2ZM7.66,7.6h9.879l-1,10.3a.992.992,0,0,1-1,.9H9.652a.993.993,0,0,1-1-.9Zm3.53,1.991a.6.6,0,0,0-.591.609v6a.6.6,0,1,0,1.2,0v-6a.6.6,0,0,0-.609-.609Zm2.8,0a.6.6,0,0,0-.591.609v6a.6.6,0,1,0,1.2,0v-6a.6.6,0,0,0-.609-.609Z",
    transform: "translate(1305.799 336)",
    fill: "#ff4d4a"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.064e41c5cdbeffffe2004fe1ab90e273.svg";
export { ForwardRef as ReactComponent };